import { TranslatableText, Translate } from '@dreryk/react-common';
import { ArrowLeftIcon, IconFillColor, IconSize, StyledFlex } from '@dreryk/react-components';

import { longWeekdayDayMonthFormatter } from './Chart.utils';
import {
   StyledTooltipInfoBlockDate,
   StyledTooltipInfoBlockIconWrapper,
   StyledTooltipInfoBlockLabel,
} from './TooltipCardInfoBlock.styled';

type TooltipCardInfoBlockProps = {
   readonly count: string;
   readonly date: Date;
   readonly difference?: number;
   readonly label: TranslatableText;
};

export const TooltipCardInfoBlock = (props: TooltipCardInfoBlockProps): JSX.Element => {
   const { count, date, difference, label } = props;

   return (
      <StyledFlex justifyContent='space-between' gap={48}>
         <StyledFlex direction='column'>
            <StyledTooltipInfoBlockLabel>
               <Translate>{label}</Translate>
            </StyledTooltipInfoBlockLabel>
            <StyledTooltipInfoBlockDate>{longWeekdayDayMonthFormatter(date)}</StyledTooltipInfoBlockDate>
         </StyledFlex>
         <StyledFlex gap={4}>
            {difference === undefined || difference === 0 ? null : (
               <StyledTooltipInfoBlockIconWrapper
                  size={IconSize.SMALLER}
                  testId={'arrow'}
                  fillColor={difference > 0 ? IconFillColor.SUCCESS : IconFillColor.ERROR}
                  $positive={difference > 0}
               >
                  <ArrowLeftIcon />
               </StyledTooltipInfoBlockIconWrapper>
            )}
            {count}
         </StyledFlex>
      </StyledFlex>
   );
};
